import React from 'react';
import { motion } from 'framer-motion';
import { Target, Users, Brain, Zap, DollarSign, ArrowDownIcon, BrainCircuit } from 'lucide-react';
import { Button } from '../shared/Button';
export const ValueStackSection = () => {
  const values = [{
    icon: <Target size={28} data-id="element-300" />,
    title: 'Career Strategy',
    description: 'Personalized roadmap & market positioning',
    details: ['10-year trajectory planning', 'Company targeting matrix', '"Keystone role" identification', 'Market opportunity analysis'],
    size: 'lg'
  }, {
    icon: <BrainCircuit size={28} data-id="element-301" />,
    title: 'Accelerated Search',
    description: 'Get 3-4 new interviews per week without lifting a finger',
    details: ['ML-driven targeting to match your skills and preferences', 'Up to 400 curated applications per week, fully automated', 'Largest, freshest database of software engineering roles', 'Customizable filters for location, role, salary, and remote-only'],
    size: 'lg'
  }, {
    icon: <Users size={28} data-id="element-302" />,
    title: 'Interview Mastery',
    description: 'Comprehensive interview preparation system',
    details: ['6-10 interview story scripts', 'Live behavioral practice', 'Resume & LinkedIn optimization', '"Game Tape" feedback reviews'],
    size: 'sm'
  }, {
    icon: <Zap size={28} data-id="element-303" />,
    title: 'Weekly Execution',
    description: 'Accountability and support system',
    details: ['2-3x weekly check-ins', 'Personalized action plans', 'Slack + text access', 'Pre-interview prep calls'],
    size: 'md'
  }, {
    icon: <Brain size={28} data-id="element-304" />,
    title: 'Technical Excellence',
    description: 'Daily technical training sessions',
    details: ['DS&A deep dives', 'System design workshops', 'Mock technical interviews', 'Code review sessions'],
    size: 'lg'
  }, {
    icon: <DollarSign size={28} data-id="element-305" />,
    title: 'Negotiation Mastery',
    description: 'Comprehensive compensation strategy',
    details: ['Offer strategy sessions', 'Positioning training', 'Comp review analysis', 'Leverage optimization'],
    size: 'md'
  }];
  return <section className="w-full bg-gradient-to-br from-[#231232] to-[#1a0d24] py-20 sm:py-28" data-id="element-306">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-307">
        <div className="text-center mb-16 sm:mb-20" data-id="element-308">
          <span className="inline-block px-4 py-1.5 bg-[#6805DA]/10 text-[#6805DA] rounded-full text-sm font-medium mb-4" data-id="element-309">
            THE COMPLETE SYSTEM
          </span>
          <h2 className="text-3xl sm:text-5xl font-outfit font-bold mb-6 text-white" data-id="element-310">
            A Complete Career Transformation System
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-[#6805DA] to-[#4B0599] mx-auto rounded-full mb-6" data-id="element-311"></div>
          <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-312">
            Everything you need to 2x your compensation and land your dream role
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-313">
          {values.map((value, index) => <motion.div key={value.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} className={`bg-[#1a0d24] rounded-xl p-6 sm:p-8 border border-white/10 hover:border-[#6805DA]/40 transition-all duration-300 shadow-lg hover:shadow-xl hover-card ${value.size === 'lg' ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-314">
              <div className="mb-6" data-id="element-315">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-lg bg-[#6805DA]/20 text-[#6805DA]" data-id="element-316">
                  {value.icon}
                </div>
              </div>
              <h3 className="text-xl sm:text-2xl font-manrope font-bold mb-3 text-white" data-id="element-317">
                {value.title.replace(/[🧠🛠🏆🎓💰]/, '')}
              </h3>
              <p className="text-gray-400 mb-6" data-id="element-318">{value.description}</p>
              <ul className="space-y-3" data-id="element-319">
                {value.details.map((detail, i) => <li key={i} className="flex items-start text-gray-300" data-id="element-320">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#6805DA] mr-3 mt-2" data-id="element-321" />
                    <span className="flex-1" data-id="element-322">{detail}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
        <div className="text-center mt-16 sm:mt-20" data-id="element-323">
          <Button variant="ghost" href="#roadmap" className="text-white/70 hover:text-white flex flex-col items-center gap-2 group" data-id="element-324">
            <span className="group-hover:text-[#FFC501] transition-colors" data-id="element-325">
              See the full roadmap
            </span>
            <ArrowDownIcon className="animate-bounce text-[#FFC501]" size={20} data-id="element-326" />
          </Button>
        </div>
      </div>
    </section>;
};